import { Result } from "../../feedback/result/Result";

const PageNotFound = () => <Result status="404" title="404" />;

export { PageNotFound };
